import ListingFilters from "../../src/js/components/listingFilters";
import Link from "../../src/js/components/Link";

document.addEventListener('DOMContentLoaded', () => {
	ListingFilters.init();
	Link.init();
});
